export const parseToChangeHistoryItem = ({
    detalles, 
    nombre,
    deportes,
    aforoMin,
    aforoMax,
    direccion,
    referencia,
    fechaHora, 
    cambios
}) => ({
    name: nombre,
    availableSports: deportes,
    minCapacity: aforoMin,
    maxCapacity: aforoMax,
    address: direccion,
    reference: referencia,
    details: detalles,
    date: fechaHora,
    changes: parseToChanges(cambios)
});
export const parseToChanges = obj => {
    if (!obj)
        return null;
    const {
        nombre, deportes,
        aforoMin, aforoMax,
        direccion, referencia, 
        detalles
    } = obj;
    return {
        details: detalles,
        name: nombre,
        availableSports: deportes,
        minCapacity: aforoMin,
        maxCapacity: aforoMax,
        address: direccion, reference: referencia
    };
}